<div *ngIf="dataLength === 0">
  <p>Contract Documents are pending finalization and will be viewable soon.</p>
</div>
<div *ngIf="dataLength > 0">
  <div *ngFor="let document of componentData | keyvalue" class="{{ document.key }}-document">
    <card-body>
      <dxo-table [data]="document.value" [stickyColumn]="false"></dxo-table>
    </card-body>
  </div>
</div>
